<template>
  <div class="home">
    <!-- <div class="programming">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="(item, index) in programList" :key="item">
          <div class="programming-container">
            <el-image class="programming-container-image" :fit="imgFit" :src="item" alt="planning-image"/>
            <el-button class="programming-container-button" type="primary" @click="handleProgramming(index)">了解更多</el-button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="service">
      <h2>{{service[0]}}</h2>
      <div class="service-rect">
        <el-image style="margin: 50px; width:160px; height:160px" fit="fill" :src="logoUrl" />
        <el-row :gutter="40">
        <el-col :xs="24" :sm="24" :md="24" :lg="{span:8, push:1}" :xl="{span:8, push:1}">
          <br>
          <h4>{{service[1]}}</h4>
          <div class="service-left">
            <p>{{service[2]}}</p>
            <p>{{service[3]}}</p>
            <p>{{service[4]}}</p>
          </div>
        </el-col>
        <el-col :xs="0" :sm="0" :md="0" :lg="8" :xl="8">
          <el-image class="service-image" fit="fill" :src="logoUrl" />
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="{span:8, pull:1}" :xl="{span:8, pull:1}">
          <br>
          <h4>{{service[5]}}</h4>
          <div class="service-right">
            <p>{{service[6]}}</p>
            <p>{{service[7]}}</p>
            <p>{{service[8]}}</p>
          </div>
        </el-col>
      </el-row>
      </div>
    </div>
    <div class="news">
      <h2>热门资讯</h2>
      <el-carousel :interval="3000" type="card" height="400px">
        <el-carousel-item v-for="item in articleList" :key="item">
          <h3 text="2xl" justify="center" @click="handleNews">{{item}}</h3>
        </el-carousel-item>
      </el-carousel>      
    </div>     -->
    <div class="programming">
      <div class="desktop-layout">
        <el-carousel :interval="3000" type="card" :cardScale="0.90" height="400px">
          <el-carousel-item v-for="(item, index) in programList" :key="item">
            <div class="programming-container">
              <el-image class="programming-container-image" :fit="imgFit" :src="item" alt="planning-image"/>
              <el-button class="programming-container-button" type="primary" @click="handleProgramming(index)">了解更多</el-button>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="mobile-layout">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="(item, index) in programList" :key="item">
            <div class="programming-container">
              <el-image class="programming-container-image" :fit="imgFit" :src="item" alt="planning-image"/>
              <el-button class="programming-container-button" type="primary" @click="handleProgramming(index)">了解更多</el-button>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="maze">
      <h2>{{maze[0]}}</h2>
      <el-row :gutter="50">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <div class="maze-info">
            <p style="color: red; font-size: 1.5em;">{{maze[1]}}</p>
            <p style="white-space: pre-wrap;">{{maze[2]}}</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-image class="maze-image" fit="cover" :src="startUrl" />
        </el-col>
      </el-row>
      <el-image fit="fill" :src="gifUrl"></el-image>
      <!-- <p class="maze-slogn">{{maze[2]}}</p> -->
    </div>
    <div class="service">
      <h2>{{service[0]}}</h2>
      <el-row :gutter="40">
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <el-card>
            <h4>{{service[1]}}</h4>
            <div class="service-left">
              <p>{{service[2]}}</p>
              <p>{{service[3]}}</p>
              <p>{{service[4]}}</p>
            </div>        
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <el-card>
            <h4>{{service[5]}}</h4>
            <div class="service-right">
              <p>{{service[6]}}</p>
              <p>{{service[7]}}</p>
              <p>{{service[8]}}</p>
            </div>        
          </el-card>   
        </el-col>
      </el-row>        
    </div>
    <div class="news">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <div class="news-article">
            <h2>热门资讯</h2>
            <el-carousel indicator-position="outside">
              <el-carousel-item v-for="(item,idx) in articleList" :key="item">
                <!-- <el-link :href="item.url" type="primary" target="_blank">
                  <h3 text="2xl" justify="center">{{item.title}}</h3>
                </el-link> -->
                <div class="scrollable-content">
                  <h2>{{ item.category }}</h2>
                  <div v-for="(it, i) in item.content" :key="it">
                    <el-link :href="it.url" type="primary" target="_blank"><p>{{ it.title }}</p></el-link>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <div class="news-event">
            <h2>最新活动</h2>
            <el-carousel indicator-position="outside">
              <el-carousel-item v-for="(item,idx) in eventList" :key="item" @click="handleEvent(idx)">
                <div class="event-container">
                  <!-- <el-image class="event-container-image" fit="cover" :src="item.pics" alt="event-image" /> -->
                  <h2 class="event-container-title" text="2xl" justify="center">{{ item.title }}</h2>
                  <p class="event-container-title" text="2xl" justify="center">{{ item.brief }}</p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>          
        </el-col>
      </el-row>
    </div>
    <!-- <div class="partners">
      <h2>合作伙伴</h2>
      <div>
        <span v-for="(item,idx) in partnerList" :key=item>
          <grid-item :gridIdx="idx" :gridIdy="idx" :itemData="item" @on-click="handlePartner(idx)" />
        </span>
      </div>
    </div> -->
  </div>
</template>


<script>
import { Store } from '@/utils/store'
import { Lang } from '@/utils/language'
import { Consts } from '@/utils/consts'
import { getNewsArticles, getNewsEvents } from '@/utils/api'
// import JsonDataArticle from '@/assets/data/新闻数据.json'
export default {
  name: 'HomeView',
  data() {
    return {
      provinceOptions: Consts.ProvinceOptionsLess,
      yearOptions: Consts.YearOptions,
      imgFit: Store.largeScreen ? 'fill' : 'contain',

      startUrl: Consts.WebUrl+'home/maze.png',
      gifUrl: Consts.WebUrl+'home/slogan.gif',
      programList: [
        Consts.WebUrl+'home/programming-1.png', 
        Consts.WebUrl+'home/programming-2.png',
        Consts.WebUrl+'home/programming-3.png'
      ],
      articleList: [],
      eventList: [
        {
          id: 2,
          title: '无忧规划第一次活动',
          brief: '这是简介',
          pics: Consts.WebUrl+'/consultant/banner.png'
        },
      ],
    }
  },
  mounted() {
    // this.articleList = JsonDataArticle;
    // this.eventList = JsonDataEvent;
    this.getArticleList();
    this.getEventList();
  },  
  computed: {
    title() {
      if (Store.lang == 'en') {
        return Lang.Home.en[0];
      } else {
        return Lang.Home.cn[0];
      }
    },
    maze() {
      if (Store.lang == 'en') {
        return Lang.Home.en[0];
      } else {
        return Lang.Home.cn[0];
      }
    },
    service() {
      if (Store.lang == 'en') {
        return Lang.Home.en[1];
      } else {
        return Lang.Home.cn[1];
      }
    },    
  },
  methods: {
    getArticleList() {
      getNewsArticles().then(res => {
        this.articleList = res.list;
      }).catch(err => {
        this.articleList = [];
      })
    },
    getEventList() {
      const listQuery = {
        page: 1,
        size: 5,
        tag: '全部',
        text: '',
      }      
      getNewsEvents(listQuery).then(res => {
        this.eventList = res.list;
      }).catch(err => {
        this.eventList = [];
      })
    },
    handleProgramming(idx) {
      switch(idx) {
        case 0:
          this.$router.push({ name: 'Position' })
          break;
        case 1:
          this.$router.push({ name: 'Planning' })
          break;
        case 2:
          this.$router.push({ name: 'Consultant' })
          break;
      }
    },
    handleEvent(idx) {
      this.$router.push({
        name: 'NewsEvents',
        // params: {
        //   nid: this.eventList[idx].id
        // }
      })
    },
    handlePartner(idx) {

    },
  }
}
</script>


<style lang="scss" scoped>
@import '@/assets/variables.scss';
// .el-carousel {
//   height: 100%; /* 确保轮播组件的高度是 100% */
// }
// .el-carousel-item {
//   display: flex; /* 使用 flex 布局确保子元素高度正确 */
//   align-items: center; /* 垂直居中 */
//   justify-content: center; /* 水平居中 */
//   height: 100%; /* 确保轮播项的高度是 100% */
// }
.home {
  margin: auto;
  width: 100%;
}
.programming {
  // background-color: rgba(255, 0, 0, 0.2); /* 调试用背景色 */
  width: auto;
}
.programming-container {
  background-color: rgba(0, 255, 0, 0.2); /* 调试用背景色 */
  position: relative; /* 设置为相对定位，以便子元素可以绝对定位 */
  // width: 100%;        /* 确保容器占满整个轮播项 */
  // height: 100%;       /* 确保容器占满整个轮播项 */
}
.programming-container-image {
  // background-color: rgba(0, 0, 255, 0.2); /* 调试用背景色 */
  width: 100%;
  height: 100%;
}
.programming-container-button {
  position: absolute; /* 绝对定位 */
  top: 80%;           /* 距离顶部80% */
  left: 50%;          /* 距离左侧50% */
  transform: translate(-50%, -50%); /* 使按钮居中 */
  z-index: 10;        /* 确保按钮在图片上方 */
}
.maze {
  text-align: center;
}
.maze-info {
  padding: 20px 0;
  text-align: left;
}
.maze-image {
  height: 360px;
  // border-color: red;
  // border-style: solid;
  // border-width: 3px;
}
.maze-slogn {
  white-space: pre-wrap;
  text-align: center;
  font-size: 1.1em;
  font-weight: 600;
}
.service {
  text-align: center;
  background-color: #EBF0EF;
}
.service-rect {
  // min-height: 400px;
  min-height: 200px;
  background-color: $theme-color;
}
.service-image {
  width: 320px;
  height: 320px;
}
.news {
  padding: 30px 0;
  .news-article {
    .el-carousel {
      height: 200px;
    }
    // .el-carousel__item h3 {
    //   margin: 0;
    //   line-height: 200px;
    //   text-align: center;
    //   color: #475669;
    //   opacity: 0.75;
    // }
    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }
    .el-carousel__item:nth-child(2n + 1) {
      background-color: #d3dce6;
    }
    .scrollable-content {
      // padding: 10px;    /* 添加一些内边距，使内容更美观 */
      height: 200px;    /* 设置一个固定高度，根据需要调整 */
      overflow-y: auto; /* 启用垂直滚动条 */
    }
  }
  .news-event {
    .el-carousel {
      height: 200px;
    }
    // .el-carousel__item {
    //   background-color: #EBF0EF;
    // }
    .el-carousel__item:nth-child(2n) {
      background-color: #FFD8BD;
    }
    .el-carousel__item:nth-child(2n + 1) {
      background-color: #FFB38A;
    }
    // .event-container {
    //   position: relative; /* 设置为相对定位，以便子元素可以绝对定位 */
    // }
    // .event-container-image {
    //   width: 100%;
    //   height: 100%;
    // }
    .event-container-title {
      // position: absolute; /* 绝对定位 */
      // z-index: 10;        /* 确保按钮在图片上方 */
      // top: 50%;           /* 距离顶部80% */
      // left: 50%;          /* 距离左侧50% */
      // transform: translate(-50%, -50%); /* 位置居中 */
      // color: white;
      padding: 30px, 20px;    /* 添加一些内边距，使内容更美观 */
      text-align: center;
      color: #3894FF;
    }
  }
}
.partner {
  padding: 30px 0;
}

/* 设置了浏览器宽度不小于1201px时 list显示的宽度 */
@media screen and (min-width: 1080px) {
  .desktop-layout {
    display: block;
  }
  .mobile-layout {
    display: none;
  }  
  .programming {
    height: calc(var(--width) * 0.20);
  }
  .programming-container {
    width: 100%;                /* 确保容器占满整个轮播项 */
    height: 100% !important;    /* 确保容器占满整个轮播项 */
  }
  .maze {
    margin-top: 40px;
    margin-left: 15%;
    margin-right: 15%;
    padding-top: 80px;
  }
  // .maze-info {
  //   padding-top: 80px;
  //   margin-left: 80px;
  // }
  .service {
    margin-top: 40px;
    padding: 50px 10%;
  }
  .service-image {
    margin-top: 50px;
  }
  .service-left {
    padding: 0 10px;
    text-align: left;
  }
  .service-right {
    padding: 0 10px;
    text-align: left;
  }
}
@media screen and (max-width: 1080px) and (orientation: portrait) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }  
  .programming {
    height: calc(var(--width) * 0.4);
  }
  .maze, .service {
    padding: 20px 5%;
  }
  // .maze-info {
  //   margin: 20px 0 20px 0;
  // }
  .service-image {
    margin: 0;
  }
  .service-left {
    padding: 0 50px;
    text-align: left;
  }
  .service-right {
    padding: 0 50px;
    text-align: left;
  }
}
</style>
